import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TransactionType } from '../../../models/common/trading-common.model';
import { TradingService } from '../../../services/common/trading-service.service';

@Component({
  selector: 'tax-lot',
  templateUrl: './tax-lot.component.html',
  styleUrls: ['./tax-lot.component.css']
})
export class TaxLotComponent implements OnInit {
  orderTitleStyle: string = 'tr-OrderTitle';
  isBdUser: boolean;
  activeTheme: string;
  constructor(
    public dialogRef: MatDialogRef<TaxLotComponent>,
    private tradingService: TradingService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {

  }

  ngOnInit() {
    this.activeTheme = this.tradingService.getActiveThemeFromCurrentContainer();
    if (this.data.tradeInfo.transactionType === TransactionType.SELL_FROM_PORTFOLIO || this.data.tradeInfo.transactionType === TransactionType.REDEEM) {
      this.orderTitleStyle = 'tr-OrderTitle_Sell';
    } else if (this.data.tradeInfo.transactionType === TransactionType.BUY_TO_COVER) {
      this.orderTitleStyle = 'tr-OrderTitle_Buy';
    } else {
      this.orderTitleStyle = 'tr-OrderTitle';
    }

    this.isBdUser = !!this.data.isBdUser ? this.data.isBdUser : false;
  }

  public print() {
    let style = document.createElement('style');
    style.media = 'print';
    style.id = 'pershing_trading_order_entry_print_style';
    let styles = 'body { visibility: hidden } tax-lot { visibility: visible; position: absolute; left: 0px; top: 0px; z-index: -1; } ' +
    'equity-order-entry-wrapper-component { display:none; } .wrapper.container-fluid { display: none }';

    style.appendChild(document.createTextNode(styles));

    document.body.appendChild(style);

    // window.print();
    document.execCommand('print', false, null);

    let element = document.getElementById('pershing_trading_order_entry_print_style');
    element.parentNode.removeChild(element);
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

}
